module.exports = __webpack_public_path__ + "img/3d-slogan.43c20bd8.webp";